import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SiteSurveyTemplate, SiteView, rng } from "../../amorg-common";
import { getAllSites, getSiteSurveyTemplates, importGlobalSurveyTemplate } from "../../api/adminClientApi";
import { LoadingPageOverlay } from "../../designSystem/LoadingPageOverlay";
import { Flex } from "../../designSystem/compositeComponents/FlexHelpers";
import { SelectField } from "../../designSystem/formField/SelectField";
import { H1, H2 } from "../../designSystem/typography/Heading"
import { SurveyTemplateList } from "./_components/SurveyTemplateList";
import { AmorgyPageWrapper } from "../_pageWrappers/AmorgyPageWrapper";
import { SingleColumnLayout } from "../_layouts/SingleColumnLayout";

export function AmorgAdminImportTemplate (): JSX.Element
{
    const navigate = useNavigate();

    const [loading, setLoading] = React.useState(true);

    const [sites, setSites] = React.useState<SiteView[]>([]);
    const [selectedSite, setSelectedSite] = React.useState("");

    const [siteTemplates, setSiteTemplates] = React.useState<SiteSurveyTemplate[]>([]);

    useEffect(() =>
    {
        const init = async () =>
        {
            const sites = await getAllSites(() => navigate(`/amorgy/login`));
            if (sites !== undefined && sites.length > 0)
            {
                setSites(sites);
                setSelectedSite(sites[0].id);
                const templates = await getSiteSurveyTemplates(sites[0].id, () => navigate(`/amorgy/login`));
                if (templates !== undefined)
                    setSiteTemplates(templates);
            }

            setLoading(false);
        };
        init().catch(console.error);
    }, []);

    async function handleSiteChange (siteId: string)
    {
        setLoading(true);
        setSelectedSite(siteId);
        const siteTemplates = await getSiteSurveyTemplates(siteId, () => navigate(`/amorgy/login`));
        if (siteTemplates !== undefined)
            setSiteTemplates(siteTemplates);
        setLoading(false);
    }

    function handleClickImport (templateId: string)
    {
        setLoading(true);
        importGlobalSurveyTemplate(
            selectedSite,
            templateId,
            rng.getRandomId(),
            'global',
            () => navigate(`/amorgy/login`)
        ).then(result =>
        {
            if (result)
                navigate('/amorgy/globaltemplates');
            else
            {
                setLoading(false);
                alert('fejl...');
            }
        });
    }

    return (

        <AmorgyPageWrapper selectedTab='globaltemplates'>
            <LoadingPageOverlay loading={loading} />

            <SingleColumnLayout narrow>
                <Flex flexDirection="column" gap={16}>
                    <H1>Importér skabelon</H1>
                    <SelectField
                        selectedValue={selectedSite}
                        options={sites.map(s => ({ value: s.id, text: s.id }))}
                        onChange={value => handleSiteChange(value)}
                        label="Valgt site" />


                    <H2>Site skabeloner</H2>
                    <SurveyTemplateList
                        templates={siteTemplates}
                        buttons={[
                            {
                                variant: 'filled',
                                text: 'Importér',
                                onClick: (templateId) => handleClickImport(templateId)
                            }
                        ]} />
                </Flex>
            </SingleColumnLayout>
        </AmorgyPageWrapper>
    );
}

